export const ROUTES = {
  home: "/",
  models: "/models",
  clubs: "/clubs",
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  setPassword: "/set-password",
  modelPanel: "/model-panel",
  profile: "/profile", // Профиль клиентов
  admin: "/admin",
  dataSecurity: "/data-security",
  abbreviation: "/abbreviation",
  agb: "/agb",
  impressum: "/impressum",
} as const;

export type RouteKeys = keyof typeof ROUTES;
export type RouteValues = (typeof ROUTES)[RouteKeys];
